const LEAD_SOURCE_STORAGE_KEY = 'loyalqr_lead_source';
const PAGEVIEW_URL =
  process.env.REACT_APP_PAGEVIEW_URL ||
  'https://nextvisit-api.unwishlist.workers.dev/api/pageview';

export function trackingSourceFromPath(path) {
  const prefix = '/landing/';
  if (!path.startsWith(prefix) || path.length <= prefix.length) return null;
  try {
    return decodeURIComponent(path.slice(prefix.length)).trim().slice(0, 100) || null;
  } catch {
    return null;
  }
}

export function resolveLeadSource(trackingSource) {
  const routeSource = trackingSource?.trim().slice(0, 100) || null;
  try {
    const storedSource = window.localStorage.getItem(LEAD_SOURCE_STORAGE_KEY);
    if (storedSource) return storedSource;
    if (routeSource) window.localStorage.setItem(LEAD_SOURCE_STORAGE_KEY, routeSource);
  } catch {
    // Fall back to the current route when storage is unavailable.
  }
  return routeSource;
}

export function analyticsPath(path) {
  return path;
}

export function trackPageView(path) {
  const source = resolveLeadSource(trackingSourceFromPath(path));
  return fetch(PAGEVIEW_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    body: JSON.stringify({
      path: analyticsPath(path),
      referrer: document.referrer || null,
      source,
    }),
  }).catch(() => {
    // Analytics must never interrupt the page being viewed.
  });
}
